var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"light-blue-button",attrs:{"outlined":"","color":"primary darken-1","disabled":_vm.disableResendWelcome},on:{"click":function($event){return _vm.resendWelcomeEmail()}}},[_vm._v("\n    Resend Welcome Email\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d39fef0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/resendWelcome.vue
// module id = null
// module chunks = 